.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  // Horizontal padding matches the modal header/footer (32px) so the body
  // content lines up with the title + action buttons. Top/bottom sit snug
  // under the sticky header and above the sticky footer.
  padding: 8px 32px 20px;
  min-width: 460px;
}

.subtitle {
  margin: -4px 0 0;
}

.origin {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
  background: var(--color-muted-background, #f9fafb);
}

.origin-icon {
  height: 18px;
  width: 18px;
  flex-shrink: 0;
  color: var(--color-muted, #6b7280);
}

.origin-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.origin-value {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.origin-route,
.origin-ref {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.req {
  color: var(--color-destructive, #ef4444);
}

.help {
  margin-top: 2px;
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.locked {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 6px;
  background: var(--color-muted-background, #f9fafb);
}

.locked-icon {
  height: 14px;
  width: 14px;
  flex-shrink: 0;
  color: var(--color-muted, #6b7280);
}

.hidden-input {
  display: none;
}

.attachments {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
}

.attachment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 6px;
  background: var(--color-muted-background, #f9fafb);
}

.attachment-thumb {
  height: 28px;
  width: 28px;
  flex-shrink: 0;
  border-radius: 4px;
  object-fit: cover;
}

.attachment-icon {
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  color: var(--color-muted, #6b7280);
}

.attachment-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--color-muted, #6b7280);
  border-radius: 4px;

  &:hover {
    color: var(--color-destructive, #ef4444);
  }
}
